module.exports = __webpack_public_path__ + "images/frontpage_hotkeys@2x.png?8ea4117c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_hotkeys@2x.png
// module id = 646
// module chunks = 7